require('./contractLoanCompilationCard.scss');
require('./contractLoanCompilationCard.override.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const classnames = require('classnames');
const { isEqual } = require('lodash/lang');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@commons
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@components
const LoanCollectiveTooltip = require('../../loansAndMortgages/loanCollectiveTooltip/loanCollectiveTooltip');
//@utilities
const { formatPercentage, getFormattedString } = require('utilities/currencyHelper');
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS }
} = require('../../../loansConstants/index');
//@assets
const summaryImg = require('../../../assets/images/no-item.png');


class ContractLoanCompilationCard extends React.Component {

    buildTin(toDefine) {
        const { immSummary, payrollLoanTooltip, nodata, callKOxDTI } = this.props;
        const immCollective = immSummary.getIn(['collectiveInformation', '0']);
        const isCollective = immSummary.get('isCollective');
        const tin = (isCollective && immCollective) ? immCollective.get('tin') : immSummary.get('tin');
        let tinItem = {
            label: formatText('contractLoanCompilationCard-TIN'),
            text: nodata && isEqual(callKOxDTI, undefined) ? toDefine : formatPercentage(tin)
        };

        if (payrollLoanTooltip) {
            tinItem = Object.assign({}, tinItem, payrollLoanTooltip);
        }

        return tinItem;
    }

    buildInstallment() {
        const { immSummary } = this.props;
        const immCollective = immSummary.getIn(['collectiveInformation', '0']);
        const isCollective = immSummary.get('isCollective');
        return (isCollective && immCollective) ? {
            amount: immCollective.get('installment'),
            currency: immSummary.get('currency')
        } : immSummary.get('installment');
    }

    buildList() {
        const { immSummary, footerList, nodata } = this.props;
        const toDefine = formatText('contractLoanCompilationCard-nodata');
        const tinItem = this.buildTin(toDefine);
        const taeItem = this.buildTae(toDefine);
        const installment = this.buildInstallment();

        let list = [
            {
                label: formatText('contractLoanCompilationCard-loanImport'),
                text: nodata ? toDefine : getFormattedString({
                    amount: immSummary.get('selectedAmount'),
                    currency: immSummary.get('currency'),
                    decimalsLength: 0
                }),
                className: 'contract-easy-loan-sidebar__loan-import'
            },
            {
                label: formatText('contractLoanCompilationCard-term'),
                text: nodata ? toDefine : formatText('contractEasyLoan-termMonths', [immSummary.get('selectedTerm')]),
            },
            {
                label: formatText('contractLoanCompilationCard-installment'),
                text: nodata ? toDefine : getFormattedString(installment)
            },
            tinItem,
            taeItem
        ];

        if (footerList) {
            list = list.concat(footerList);
        }

        const listComponent = list.map((item, index) => {
            const listElementClass = classnames(
                'contract-loan-compilation-card__list-item',
                item.className
            );

            return (
                <OKInformativeListItem
                    bodyText={item.text}
                    className={listElementClass}
                    icon={item.icon}
                    iconCustomClass={item.iconCustomClass}
                    information={item.information}
                    key={index}
                    title={item.label}
                    additionalLabel={item.additionalLabel}
                    tooltipClassName={item.tooltipClassName}
                    tooltipOffset={item.tooltipOffset}
                    tooltipPlacement={item.tooltipPlacement}
                    tooltipModifier={item.tooltipModifier}
                    compact
                />
            );
        });

        return (
            <OKInformativeList>
                {listComponent}
            </OKInformativeList>
        );
    }

    buildTae(toDefine) {
        const { immSummary, taeTooltip, nodata, callKOxDTI } = this.props;
        const immCollective = immSummary.getIn(['collectiveInformation', '0']);
        const isCollective = immCollective && immSummary.get('isCollective');
        const tae = isCollective ? immCollective.get('tae') : immSummary.get('tae');

        const taeItem = {
            text: nodata && isEqual(callKOxDTI, undefined) ? toDefine : formatPercentage(tae),
            label: formatText('contractLoanCompilationCard-TAE'),
            className: 'item-tae',
        }

        if (taeTooltip) {
            taeItem.icon = 'icon-informacion';
            taeItem.tooltipPlacement = 'top';
            taeItem.tooltipClassName = 'contract-loan-compilation-card__tooltip';
            taeItem.iconCustomClass = 'contract-loan-compilation-card__tae-icon';
            taeItem.tooltipModifier = 'dark-bg';
            taeItem.tooltipOffset = [0, -10];
            taeItem.information = taeTooltip;
        }

        return taeItem;
    }

    buildBadge() {
        const { setCurrentProductCollective } = this.props;

        return (
            <CollectiveTag
                extraClass="contract-loan-compilation-card__container-collective-mark"
                productAlias={PAYROLL_LOAN_ALIAS}
                setCurrentProductCollective={setCurrentProductCollective}
                tooltipContent={<LoanCollectiveTooltip />}
            />
        );
    }

    buildSectionBox() {
        const { selectedPurposeSection, isLoading } = this.props;
        const list = this.buildList();
        const badge = this.buildBadge();

        return (
            <OKSectionBox className="contract-loan-compilation-card">
                {selectedPurposeSection}
                <div className="contract-loan-compilation-card__header">
                    <FormattedText
                        className="contract-loan-compilation-card__summary-title"
                        value="contractLoanCompilationCard-summary"
                    />
                    {badge}
                </div>
                <div className="contract-loan-compilation-card__list">
                    {isLoading ? <LoadingSection /> : list}
                </div>
            </OKSectionBox>
        );
    }

    buildSectionBoxStepOne() {
        return (
            <OKSectionBox className="contract-loan-compilation-card">
                <div className="contract-loan-compilation-card__summary-step-one">
                    <img className="" src={summaryImg} />
                    <FormattedText
                        className="contract-loan-compilation-card__summary-step-one__title"
                        value="contractLoanCompilationCard-stepOneSummaryTitle"
                    />
                    <FormattedText
                        className="contract-loan-compilation-card__summary-step-one__text"
                        value="contractLoanCompilationCard-stepOneSummaryText"
                    />
                </div>
            </OKSectionBox>
        );
    }

    render() {
        const { immSummary, isPayrrolLoan } = this.props;
        const sectionBox = this.buildSectionBox();
        const sectionBoxStepOne = this.buildSectionBoxStepOne();
        const visibleStep = immSummary.get("visibleStep");
        const isStepOne = visibleStep === 1;
        const content = isStepOne && isPayrrolLoan ? sectionBoxStepOne : sectionBox;

        return <div>{content}</div>;
    }
}

ContractLoanCompilationCard.defaultProps = {
    isLoading: false,
}

ContractLoanCompilationCard.propTypes = {
    callKOxDTI: PropTypes.bool,
    footerList: PropTypes.array,
    immSummary: PropTypes.object.isRequired,
    isCollective: PropTypes.bool,
    nodata: PropTypes.bool,
    payrollLoanTooltip: PropTypes.object,
    selectedPurposeSection: PropTypes.object,
    setCurrentProductCollective: PropTypes.func,
    taeTooltip: PropTypes.object,
    isLoading: PropTypes.bool,
    isPayrrolLoan: PropTypes.bool,
};

module.exports = ContractLoanCompilationCard;
